<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="queenIntroductionForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                queenIntroductionForm: () => import('../forms/QueenIntroductionForm'),
                headers: [
                    { text: 'Queen Purchase', value: 'queenPurchaseId', table: 'queenPurchases', form: () => import('../forms/QueenPurchaseForm') },
                    { text: 'Queen Number', value: 'queenNumber' },
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Load', value: 'loadId', table: 'loads', form: () => import('../forms/LoadForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    loads: [],
                    queenPurchases: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "queenNumber", direction: "ascending" },
                    { column: "loadId", direction: "ascending" },
                ],
                itemsField: 'queenIntroductions',
                editPageName: 'queenIntroduction',
                apiMethod: 'QueenIntroductions',
                claimName: 'QueenIntroductions',
                formTitle: 'Queen Introduction',
                excelTitle: 'Queen Introductions',
                hasEditPage: false,
            }
        },
    };
</script>
